module.exports = __webpack_public_path__ + "9c1145675e395959fe9bae24e3f255bd.pdf";